export class ServiceError extends Error {
  code: number;
  duration ?: number;
  data?: any;
  constructor(code: number, message: string ,data?: any,duration ?: number) {
    super(message);
    this.code = code;
    this.data = data;
     if (duration) {
      this.duration = duration;
    }
  }
}
